module.exports = __webpack_public_path__ + "img/logoChrome_c.6fd7372b.svg";